import React from "react";

const SmileyIcon = ({ width = 24, height = 24, fillColor = "#F45E29" }) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={width}
      height={height}
      viewBox="0 0 24 24"
      fill="none"
    >
      {/* Outer circle for the face */}
      <circle cx="12" cy="12" r="10" fill={fillColor} />

      {/* Eyes */}
      <circle cx="8.5" cy="10" r="1" fill="#000" />
      <circle cx="15.5" cy="10" r="1" fill="#000" />

      {/* Smile */}
      <path
        d="M8 15c1.5 2 4.5 2 6 0"
        stroke="#000"
        strokeWidth="1.5"
        strokeLinecap="round"
        fill="none"
      />
    </svg>
  );
};

export default SmileyIcon;
